import React, { Component } from 'react'
import { push, goBack } from 'react-router-redux';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import shortid from 'shortid'
import { parseString } from 'dxf'
import Hashids from 'hashids'


import './LockedFeatureModal.css';

import Button from '../../components/Button/Button.js'
import Tabs from '../../components/Tabs/Tabs.js'
import LoginForm from '../../components/LoginForm/LoginForm.js'

import { hideLockedFeatureModal } from '../../actions/actions.export.js';

var pf_config = require('../../pf_config.json');

var hashids = new Hashids('k100p');

class LockedFeatureModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      
    }

    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleCloseModal(){
    const { dispatch } = this.props;

    dispatch(hideLockedFeatureModal())
  }


  render(){
    const { dispatch, globalReducer, user, team } = this.props; 
    
    if(!globalReducer.lockedFeatureModal.open) return "";

    var feature = pf_config.features[globalReducer.lockedFeatureModal.feature_name];

    var account_level_required = 'open';
    if(!feature.availability.open) account_level_required = 'pro';
    if(!feature.availability.pro) account_level_required = 'teams';

    return <div className="modal theme-light">
      <div className="modal-bg" onClick={this.handleCloseModal}>
      </div>
      <div className="modal-inner">
        <div className="flex-split">
          <span>
            
          </span>
          <span>
            <Button size="squared-normal" color="borderless" display={<i className="fal fa-times fa-lg fa-fw"/>} onClick={this.handleCloseModal}/> 
          </span>
        </div>
        
        <div className="flex-column">
          {
            account_level_required === 'open' && <i className="fad fa-user-circle fa-5x text-award"/>
          }
          {
            account_level_required === 'pro' && <i className="fad fa-award fa-5x text-award"/>
          }
          {
            account_level_required === 'teams' && <i className="fad fa-users fa-5x text-award"/>
          }
          <br/>
          <h4>
            {
              account_level_required === 'open' && <span>
                {
                  (user.isLoggedIn && !user.email_verified) && 
                  <span>Verify your email to {feature.in_a_sentence}.</span>
                }
                {
                  !user.isLoggedIn && 
                  <span>Sign up for free to {feature.in_a_sentence}.</span>
                }
              </span>
            }
            {
              account_level_required === 'pro' && <span>
                {feature.display_name} is a paid feature.
              </span>
            }
            {
              account_level_required === 'teams' && <span>
                {feature.display_name} is a paid feature exclusive to Pattycake Firms.
              </span>
            }
          </h4>
          <br/>

          {
            ((user.delinquent && user.roles.pro && !team.current) || (team.current && team.cache[team.current].delinquent) || (team.current && team.cache[team.current].subscription_ended)  || (team.current && team.cache[team.current].overstaffed)) ?
            <p className="text-center div-danger" style={{maxWidth: 400}}> 
              {
                (user.delinquent && user.roles.pro && !team.current) && 
                <span>
                  Your account is currently upgraded to Pro, but there was an issue with your last invoice. Please update your billing information and pay any past due invoices to continue using Pattycake.
                </span>
              }
              {
                (team.current && team.cache[team.current].delinquent) && 
                <span>
                  We couldn't process your most recent payment for the <strong>{team.cache[team.current].display_name}</strong> team account. Please update your billing information and pay any past due invoices to continue using Pattycake.
                </span>
              }
              {
                (team.current && team.cache[team.current].subscription_ended) && 
                <span>
                  Your firm's subscription is no longer active. Please restart your subscription via your firm's settings to use this feature.
                </span>
              }
              {
                (team.current && team.cache[team.current].overstaffed) && 
                <span>
                  Your firm is locked due to being overstaffed. The number of seats on its license needs to be increased, or members removed in order to continue.
                </span>
              }
            </p>
            :
            <p className="text-center" style={{maxWidth: 400}}> 
              {
                (account_level_required === 'open' && !user.isLoggedIn) && <span>
                  Get access to this and dozens more features by creating a free Pattycake Open Source account. No credit card required!
                </span>
              }
              {
                (account_level_required === 'open' && user.isLoggedIn && !user.email_verified) && <span>
                  You've already signed up, now just verify your email address to get access to this and dozens more features!
                </span>
              }
              {
                account_level_required === 'pro' && <span>
                  Go pro and take your patterns to the next level. Save private patterns, unlock the full template library, and create the perfect .PAT file for your drawings.
                </span>
              }
              {
                account_level_required === 'teams' && <span>
                  Start baking at work with Pattycake for Firms. Collaborate with your team on private patterns, track standards across projects, customize the .PAT file format and more.
                </span>
              }
            </p>
          }
          <br/>
          {
            ((user.delinquent && user.roles.pro && !team.current) || (team.current && team.cache[team.current].delinquent) || (team.current && team.cache[team.current].subscription_ended) || (team.current && team.cache[team.current].overstaffed)) ?
            <div> 
              {
                (user.delinquent && user.roles.pro && !team.current) && 
                <Link to="/settings/my-account/billing" className="button-link">
                  <Button
                    size="large"
                    color="grey"
                    display="Go to Billing Settings"
                  />
                </Link>
              }
              {
                (team.current && team.cache[team.current].delinquent) && <div>
                  {
                    team.cache[team.current].myRole === "admin" ?
                    <Link to={"/settings/" + (team.cache[team.current].isFirm ? "firm/" : "team/") + hashids.encode(team.current) + "/billing"} className="button-link">
                      <Button
                        size="large"
                        color="grey"
                        display="Go to Billing Settings"
                      />
                    </Link>
                  :
                  <span>Contact your account administrator for help.</span>
                  }
                </div>
              }
              {
                (team.current && team.cache[team.current].overstaffed) && <div>
                  {
                    team.cache[team.current].myRole === "admin" ?
                    <Link to={"/settings/" + (team.cache[team.current].isFirm ? "firm/" : "team/") + hashids.encode(team.current) + "/members/access"} className="button-link">
                      <Button
                        size="large"
                        color="grey"
                        display="Manage Members"
                      />
                    </Link>
                  :
                  <span>Contact your account administrator for help.</span>
                  }
                </div>
              }
              {
                (team.current && team.cache[team.current].subscription_ended) && <div>
                  {
                    team.cache[team.current].myRole === "admin" ?
                    <Link to={"/settings/" + (team.cache[team.current].isFirm ? "firm/" : "team/") + hashids.encode(team.current) + "/billing"} className="button-link">
                      <Button
                        size="large"
                        color="grey"
                        display="Go to Billing Settings"
                      />
                    </Link>
                  :
                  <span>Contact your account administrator for help.</span>
                  }
                </div>
              }
            </div>
            :
            <div>
              {
                (account_level_required === 'open' && !user.isLoggedIn) && <strong>
                  <Link to="/sign-up" className="button-link">
                    <Button
                      size="large"
                      color="success"
                      display="Sign Up for Free"
                    />
                  </Link>
                </strong>
              }
              {
                (account_level_required === 'open' && user.isLoggedIn && !user.email_verified) && <strong>
                  <Link to="/settings/my-account/email/verify" className="button-link">
                    <Button
                      size="large"
                      color="grey"
                      display="Email Settings"
                    />
                  </Link>
                </strong>
              }
              {
                account_level_required === 'pro' && <strong>
                  {
                    !user.isLoggedIn ?
                    <Link to="/sign-up?after=bXkvZGFzaGJvYXJkL3VwZ3JhZGUtdG8tcHJv" className="button-link">
                      <Button
                        size="large"
                        color="success"
                        display="Get Pattycake Pro"
                      />
                    </Link>
                    :
                    <Link to="/settings/my-account/upgrade-to-pro" className="button-link">
                      <Button
                        size="large" 
                        display="Upgrade to Pro"
                        color="success"
                        />
                    </Link>
                  }
                </strong>
              }
              {
                account_level_required === 'teams' && <strong>
                  {
                    !user.isLoggedIn ?
                    <Link to="/sign-up?after=Y3JlYXRlLWEtdGVhbQ==" className="button-link">
                      <Button
                        size="large"
                        color="success"
                        display="Create a Firm"
                      />
                    </Link>
                    :
                    <Link to="/pattycake-for-firms-sign-up" className="button-link">
                      <Button
                        size="large"
                        display="Create a Firm"
                        color="success"
                        />
                    </Link>
                  }
                </strong>
              }
            </div>
          }
          <br/>
          <em><small><Link to="/feature-table" className="subtle">See a complete feature comparison</Link></small></em>
        </div>
      </div>
    </div>
    
  }
}
const mapStateToProps = (state) => {
  const { globalReducer, user, team } = state;

  return {
    globalReducer, user, team
  }
}

export default connect(mapStateToProps)(LockedFeatureModal);



// WEBPACK FOOTER //
// ./src/components/LockedFeatureModal/LockedFeatureModal.js